export enum LoginTypes {
  USER = "USER",
  COMPANY = "COMPANY",
  ADMIN = "ADMIN",
}
